import React from 'react';
// import Loadable from 'react-loadable';
import loadable from '@loadable/component';
import { message } from '@/components/AntD';
import { createRouter } from '@/utils/router';
import * as Cookie from '@/utils/cookie';
import PAGE from '@/constants/page';
import Loading from '@/components/Loading';
import userapi from '@/api/userapi';
import audiobookapi from '@/api/audiobookapi';
import spider, { addTrack } from '@/business/spider';
import Utils from '@/utils/utils';
import App from './App';

export default createRouter({
  getComponent: () => App,
  onEnter: async (nextState, history, cb) => {
    spider.init();
    const { location, match, query } = nextState;
    const cookie = Cookie.getCookie();
    const isMatch = match && match.isExact;
    const { pwd, user: decodeUser } = redirectToAdviser(query);
    const user = query.user || decodeUser || '';
    // 已登录
    if(user && pwd) {
      userapi.login({
        userName: decodeURIComponent(user),
        pwd,
        serveType: 'audio'
      })
        .then(res => {
          Cookie.saveCookie(res.token);
          message.success('登录成功');
          userapi.getUserInfo().then(res => {
            spider.setUserId(res.partyId);
            // addTrack('LOGIN', '4271', '6.0');
          });
          // 数字编辑工作室跳转过来 优先获取query上empId，没有的话接口获取
          let empId = Utils.params2json(location.search)['empId'];
          if(empId && empId !== '-1') {
            localStorage.setItem('empId', empId);
          } else {
            audiobookapi.getEmployeeIdByAdviserIdAndJobId().then(res => {
              if(res) {
                localStorage.setItem('empId', res);
              } else {
                localStorage.setItem('empId', '');
              }
            });
          }
          setTimeout(() => {
            if(query.redirectURL) {
              history.replace(decodeURIComponent(query.redirectURL));
            } else {
              history.replace(PAGE.HOME);
            }
          }, 100);
        })
        .catch(() => {
          addTrack('LOGIN', '4272', '6.0');
          history.replace(PAGE.LOGIN);
        })
        .finally(() => {
          cb();
        });
    } else if(cookie) {
      // index route
      if(PAGE.LOGIN === location.pathname) {
        // history.replace(PAGE.HOME);
      } else if(location.pathname === '/') {
        // history.replace(PAGE.HOME);
      }
      cb();
    } else {    // 未登录
      if(location.pathname.startsWith('/main') || isMatch) {
        history.replace(PAGE.LOGIN);
      }
      cb();
    }
  },
  getChildRoutes: () => [
    {
      path: '/rays7',
      component: loadable(() => import('./pages'), { fallback: Loading })
    },
    {
      path: '/mobilesubmit',
      component: loadable(() => import('./home/Mobile/MobileContact'), { fallback: Loading })
    },
    {
      component: loadable(() => import('./404'), { fallback: Loading })
    }
  ]
});

function redirectToAdviser(query) {
  let {
    user,
    pwd,
    encrypt = '',
    encryptInfo = ''
  } = query;
  if(encryptInfo && encrypt === 'aes') {
    let decryptInfo = Utils.decrypt(encryptInfo);
    const decryptRow = Utils.params2json(decryptInfo);
    let { user: eUser, pwd: ePwd, startMs, durMs }  = decryptRow;
    if(startMs && durMs) {
      let nowMs = Date.now();
      let isLegit = (nowMs < (Number(startMs) + Number(durMs))) && (nowMs + 300000 > Number(startMs));
      if(!isLegit) {
        alert('链接已失效');
        return {};
      }
    }
    if(eUser && ePwd) {
      user = decodeURIComponent(eUser);
      pwd = ePwd;
    }
  }
  if(user && pwd) {
    //let values = { username: user, password: pwd, isRemember: 1, encrypt, fromType, originUserId };
    return { user, pwd };
  }
  return query;
}
